import { combineReducers } from 'redux';

import { AuthenticationReducer } from '../reducers/AuthenticationReducer';
import { RsvpReducer } from '../reducers/RsvpReducer';

export const AppReducer = combineReducers({
  authentication: AuthenticationReducer,
	rsvp: RsvpReducer
});



// WEBPACK FOOTER //
// ./state/reducers/AppReducer.js